import { Delete, Edit } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import { Button, Typography } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Autocomplete from "@mui/material/Autocomplete";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Slide from "@mui/material/Slide";
import Stack from "@mui/material/Stack";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";
import { StyleSheet } from "@react-pdf/renderer";
import "firebase/firestore";
import { doc, setDoc } from "firebase/firestore";
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import { db } from "../../api/firebase";
import {
  nbfOrderItems,
  nbfModificationItems,
  nbfPrductionOrder,
} from "../../api/restApi";
import OverlayLoader from "./OverlayLoader";
import useMediaQuery from '@material-ui/core/useMediaQuery';



const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const styles = StyleSheet.create({
  label1: {
    flexDirection: "row",
    flexWrap: "wrap",
    width: "50%",
    borderWidth: 1,
    borderColor: "#bff0fd",
  },
  label2: {
    flexDirection: "row",
    flexWrap: "wrap",
    width: "50%",
    borderWidth: 1,
    borderColor: "#bff0fd",
  },
});

export default function ProductionModal({
  openProModal,
  handleClose,
  selectedRow,
  selectedDate,
  handleStatus,
  statusOrderItem,
  statusModifyOrder,
}) {
  const isMediumScreen = useMediaQuery('(min-width: 960px)');
  const product = useSelector((state) => state.products.products);
  const [products, setProducts] = useState([]);
  const [orderItems, setOrderItems] = useState([]);
  const [showOrders, setShowOrders] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [quantity, setQuantity] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [openLoader, setOpenLoader] = useState(false);
  const name = useSelector((state) => state.currentUser.name);

  const componentRef = useRef();

  const ProductDropdown = product.map((product) => {
    const data = {
      id: product.id,
      ...product,
    };
    data["label"] = data.name_english + " " + data.name_urdu;
    return data;
  });

  useEffect(() => {
    resetOrderItem();
  }, [products]);
  const resetOrderItem = () => {
    setOrderItems([]);
  };

  const handleSelectCustomer = async () => {
    // console.log(selectedDate, selectedRow?.id);
    setOpenLoader(false);

    //console.log(selectedCustomerOrders);
    try {
      if (statusModifyOrder) {
        const selectedCustomerOrders = await nbfModificationItems(
          selectedDate,
          selectedRow?.id
        );
        setOrderItems(selectedCustomerOrders);
      }
      if (!statusModifyOrder) {
        const selectedCustomerOrders = await nbfOrderItems(
          selectedDate,
          selectedRow?.id
        );
        setOrderItems(selectedCustomerOrders);
      }

      setSelectedCustomer(selectedRow);

      setQuantity();
      setSelectedProduct(null);

      setShowOrders(true);
      setOpenLoader(false);
    } catch (error) {
      console.log(error);
      setOpenLoader(false);
    }
  };

  useEffect(() => {
    if (selectedRow !== null && selectedRow !== undefined) {
      handleSelectCustomer();
    }
  }, [selectedRow]);

  const handleSelectProduct = (event, newValue) => {
    setSelectedProduct(newValue);
    let item = orderItems.find((item) => item.id === newValue.id);
    setQuantity(item.quantity);
  };

  const addProduct = async () => {
    if (
      !selectedCustomer ||
      !selectedProduct ||
      isNaN(quantity) ||
      quantity < 0
    ) {
      return;
    }
    const newQuantity = parseFloat(quantity);

    let index = orderItems.findIndex((item) => item.id === selectedProduct.id);
    if (index > -1) {
      let tempAray = [...orderItems];
      tempAray[index] = {
        ...tempAray[index],
        quantity: newQuantity,
      };
      setOrderItems([...tempAray]);
      toast.success("Product added Successfully !", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    } else {
      let tempAray = [...orderItems];
      tempAray.push({
        ...selectedProduct,
        quantity: newQuantity,
      });
      setOrderItems([...tempAray]);
    }
    setQuantity();
    setSelectedProduct("");
  };

  const handleSaveOrder = async () => {
    const confirmed = await Swal.fire({
      title: "Are you sure?",
      text: "Do You want to submit this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Submit it!",
    });

    if (confirmed.isConfirmed) {
      try {
        const customerId = selectedRow.id;
        const status = "production";
        handleClose();
        await nbfPrductionOrder(orderItems, status, customerId,name,selectedDate);
        // Creating empty fields
        await setDoc(doc(db, "Order", selectedDate), {
          dummy: "",
        });
        toast.success("Successfully Submit Order !", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1000,
        });
        setSelectedCustomer(null);
        setShowOrders(false);
        handleStatus(selectedDate);
      } catch (error) {
        console.error("Error saving order: ", error);
        toast.error("Error saving order", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    } else {
      return;
    }
  };
  const handleDelete = async (id) => {
    const confirmed = await Swal.fire({
      title: "Are you sure?",
      text: "Do You want to delete this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Submit it!",
    });
    if (confirmed.isConfirmed) {
      try {
        setOrderItems(orderItems.filter((item) => item.id !== id));
        toast.success("Product deleted Successfully !", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1000,
        });
      } catch (error) {
        console.error("Error To Delete: ", error);
        toast.error("Error To Delete", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    } else {
      return;
    }
  };

  const handleEdit = (row) => {
    setSelectedProduct(row);
    // setQuantity(row.quantity);
  };

  const myIsOptionEqualToValue = (option, value) => {
    return option.label === value.label && option.value === value.value;
  };

  return (
    <div>
      <Dialog
        fullScreen
        open={openProModal}
        onClose={handleClose}
        TransitionComponent={Transition}
        style={{ zIndex: 1000 }}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h5" align="center">
              Production
            </Typography>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>

        <Grid align="center">
        <Stack
                      justifyContent= "center"
                      alignItems= "center"
                      spacing={1}
                      direction={"row"}
                      marginBottom="1rem"
                      marginTop={"1rem"} 
                  >
                  <label  style={{ minWidth: isMediumScreen ? '330px' : '150px' }}>
                    <Typography fontSize={"18px"} fontWeight="bold" color={'#1976D2'} textAlign={'start'} borderBottom='0.3px solid gray'>
                      {selectedCustomer?.name_english}
                    </Typography>
                  </label>
                  <label  style={{ minWidth: isMediumScreen ? '330px' : '150px' }}>
                    <Typography fontSize={"18px"} fontWeight="bold" color={'#1976D2'} textAlign={'end'} borderBottom='0.3px solid gray'>
                      {selectedCustomer?.name_urdu}
                    </Typography>
                  </label>
                  </Stack>
        </Grid>
        <Stack alignItems="center">
          <Card sx={{minWidth: isMediumScreen ? "680px" : 310}}>
            <CardContent>

              <Stack
                      alignItems="center"
                      spacing={1}
                      direction="row"
                      marginBottom="1rem"
                      display={"flex"}
                      justifyContent={"center"}
                  >
                    <label  style={{minWidth: isMediumScreen ? '220px' : '130px' }}>
                    <Autocomplete
                        freeSolo
                        disablePortal
                        id="combo-box-demo"
                        options={ProductDropdown}
                        sx={{ minWidth: "100%" }}
                        value={selectedProduct}
                        isOptionEqualToValue={myIsOptionEqualToValue}
                        onChange={handleSelectProduct}
                        renderInput={(params) => (
                          <TextField {...params} label="Select Products" />
                        )}
                      />
                    </label>
                    <label  style={{ minWidth: isMediumScreen ? '220px' : '110px' }}>
                    <TextField
                          value={quantity || ""}
                          onChange={(event) => setQuantity(event.target.value)}
                          sx={{ minWidth: "100%"}}
                          id="outlined-basic"
                          label="Qunatity"
                          variant="outlined"
                    />
                    </label>
                    <label  style={{minWidth: isMediumScreen ? '220px' : '50px' }}>
                    <Button
                      variant="contained"
                      sx={{minWidth:'100%',height:"55px"}}
                      onClick={addProduct}
                      size="small"
                    >
                  Add 
                </Button>
                </label>
                </Stack>
                    <Stack
                      alignItems="center"
                      spacing={4}
                      direction="row"
                      marginBottom="1rem"
                      display={"flex"}
                      justifyContent={"center"}
                  >
                    <label  style={{ minWidth: isMediumScreen ? '220px' : '340px' }}>
                    <Button
                        variant="contained"
                        sx={{  bgcolor: "green", height:'55px',minWidth:'100%' }}
                        onClick={handleSaveOrder}
                    >
                  {isLoading ? (
                    <CircularProgress sx={{ color: "#fff" }} size={30} />
                  ) : (
                    "Submit"
                  )}
                </Button>
                    </label>
                    </Stack>

              <Stack
                ref={componentRef}
                direction={"row"}
                justifyContent="center"
              >
                <Table
                  sx={{ maxWidth: 600, marginTop: "1rem" }}
                  aria-label="simple table"
                >
                  <TableHead>
                    <Typography
                      fontSize={"18px"}
                      fontWeight="bold"
                    ></Typography>
                    <TableRow sx={{}}>
                      <TableCell>
                        <Typography fontSize={"14px"} fontWeight="bold">
                          Product
                        </Typography>
                      </TableCell>
                      <TableCell align="top">
                        <Typography fontSize={"14px"} fontWeight="bold">
                          Product 
                        </Typography>
                      </TableCell>
                      <TableCell align="right">
                        {" "}
                        <Typography fontSize={"14px"} fontWeight="bold">
                          Qunatity{" "}
                        </Typography>
                      </TableCell>
                      <TableCell align="right">
                        {" "}
                        <Typography
                          fontSize={"14px"}
                          fontWeight="bold"
                          align="center"
                        >
                          Action{" "}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {orderItems &&
                      orderItems.map((row) => (
                        <TableRow key={row.id} sx={{}}>
                          <TableCell
                            component="th"
                            scope="row"
                            fontWeight="bold"
                          >
                            {row.name_english}
                          </TableCell>
                          <TableCell align="left" fontWeight="bold">
                            {row.name_urdu}
                          </TableCell>
                          <TableCell align="right" fontWeight="bold">
                            {row.quantity}
                          </TableCell>
                          <TableCell align="right" fontWeight="bold">
                            <Tooltip title="Edit">
                              <IconButton
                                aria-label="edit"
                                onClick={() => handleEdit(row)}
                              >
                                <Edit fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Delete">
                              <IconButton
                                aria-label="delete"
                                onClick={() => handleDelete(row.id)}
                              >
                                <Delete fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </Stack>
            </CardContent>
          </Card>
        </Stack>
      </Dialog>
      <OverlayLoader openLoader={openLoader} />
    </div>
  );
}
